import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldList } from 'components';
import { Button, Col, Row } from 'react-bootstrap';
import * as Actions from 'actions';
import * as Api from 'api';
import { copy, emit } from 'utils';
import { connect } from 'react-redux';

@connect(() => ({}), Actions)
class CreateNotification extends Component {
  static propTypes = {
    onCreate: PropTypes.func,
    userFilters: PropTypes.object
  }
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSend = this.handleSend.bind(this);

    this.state = {
      sending: false,
      notification: {},
    }
  }
  handleChange(value, name) {
    const notification = copy(this.state.notification);
    notification[name] = value;
    this.setState({ notification });
  }
  validateNotification(notification) {
    if(!notification.title) {
      throw new Error('Please provide a valid notifiction title.');
    }
    if(!notification.type) {
      throw new Error('Please select a notification type.');
    }
    if(!notification.message) {
      throw new Error('Plese provide a valid message.');
    }
    if(notification.link && !notification.link.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi)) {
      throw new Error('You must provide a valid link (eg: https://www.happy.com).');
    }
  }
  handleSend() {
    try {
      this.validateNotification(this.state.notification);
      this.setState({ sending: true });
      emit('create-notification', { data: {
        user_filters: this.props.userFilters || {},
        ...this.state.notification
      }})
      .then(response => {
        this.props.notify({ message: 'Notification created!'}, { type: 'success' });
        if(this.props.onCreate) {
          this.props.onCreate();
        }
      })
      .catch(error => this.props.notify(error))
      .then(e => this.setState({ sending: false }));
    }
    catch(ex) {
      this.props.notify(ex);
    }
  }
  render() {
    return (
      <div>
        <h3>Create Notification</h3>
        <div>
          <div style={{ zIndex: 99 }}>
            <FieldList
              disabled={this.props.saving}
              ref='fieldList'
              hidePanel={true}
              groupHeadings={false}
              entity={this.state.notification}
              onChange={this.handleChange}
              fields={[
                { type: 'text', name: 'message', label: 'Message', placeholder: 'Enter a message.' },
                { type: 'text', name: 'title', label: 'Title', placeholder: 'Enter a title.' },
                { type: 'text', name: 'link', label: 'Link', placeholder: 'http://'},
                ...this.state.notification.type !== 'MAP_ANNOUNCEMENT' ? []: [
                  { type: 'text', name: 'map_id', label: 'Map ID', placeholder: 'Enter a valid map id.'}
                ],
                { type: 'select', name: 'type', label: 'Type', options: [
                  { label: 'General Announcement', value: 'GENERAL_ANNOUNCEMENT' },
                  { label: 'Clients Impacted', value: 'CLIENTS_IMPACTED' },
                  { label: 'Map Announcement', value: 'MAP_ANNOUNCEMENT'},
                ]},
              ]}
            />
          </div>
          <hr className='dotted text-muted mt-sm mb-sm' />
          <h4>Options</h4>
          <FieldList
            disabled={this.props.saving}
            ref='fieldList'
            hidePanel={true}
            groupHeadings={false}
            entity={this.state.notification}
            onChange={this.handleChange}
            fields={[
              { type: 'checkbox', name: 'should_push_notification', label: 'Send Mobile Notification', value: false },
              { type: 'checkbox', name: 'push_notification_only', label: 'Only Send to Mobile', value: false }
            ]}
          />
        </div>

        <Row className='mt-lg'>
          <Col xs={12}>
            <Button disabled={this.state.sending} onClick={e => this.handleSend()} block bsStyle='primary'><i className={`fa fa-send${ this.state.sending ? ' fa-spinner fa-spin' : ''}`} /> Send {typeof this.props.total !== 'undefined' ? `to ${this.props.total} User${this.props.total > 1? 's':''}` : null}</Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CreateNotification;



// WEBPACK FOOTER //
// ./src/browser/components/notifications/create-notification.js